export const DEFAULT_KEYS = ["fuel_price", "loaded_mpg", "empty_mpg", "maintenance_cpm", "driver_mode", "driver_flat", "driver_rate", "driver_hours"];

const key = (userId) => `brv_defaults_${userId}`;

export function loadDefaults(userId) {
  try {
    return JSON.parse(localStorage.getItem(key(userId))) || null;
  } catch {
    return null;
  }
}

export function saveDefaults(userId, form) {
  const d = Object.fromEntries(DEFAULT_KEYS.map((k) => [k, form[k]]));
  localStorage.setItem(key(userId), JSON.stringify(d));
  return d;
}

export function clearDefaults(userId) {
  localStorage.removeItem(key(userId));
}
